"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChatAdapter = void 0;
class BaseChatAdapter {
    constructor(storage, updateState) {
        this.eventHandlers = {
            onMessage: () => { },
            onConnectionStateChanged: () => { },
            onUserConnected: () => { },
            onUserDisconnected: () => { },
            onUserPresenceChanged: () => { },
            onUserTyping: () => { },
        };
        this.storage = storage;
        this.updateState = updateState;
    }
    off(evtType, evtHandler) {
        const key = this.getEventKey(evtType);
        if (key in this.eventHandlers) {
            this.eventHandlers[key] = () => { };
        }
    }
    on(evtType, evtHandler) {
        const key = this.getEventKey(evtType);
        if (key in this.eventHandlers) {
            this.eventHandlers[key] = evtHandler;
        }
    }
    getEventKey(evtType) {
        return `on${evtType.charAt(0).toUpperCase()}${evtType.substring(1)}`;
    }
}
exports.BaseChatAdapter = BaseChatAdapter;
//# sourceMappingURL=BaseChatAdapter.js.map